var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnalytics({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2509 4.21217C14.7709 2.58462 13.4133 1.22708 11.7858 0.747069C10.5482 0.387058 9.6932 0.417059 9.10069 0.859572C8.38817 1.39209 8.30566 2.35212 8.30566 3.03464V4.90219C8.30566 6.74724 9.14569 7.68477 10.7957 7.68477H12.9483C13.6233 7.68477 14.5908 7.60227 15.1234 6.88975C15.5809 6.30473 15.6184 5.44971 15.2509 4.21217Z",
    fill: "#075FCC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M13.181 9.0199C12.986 8.7949 12.7009 8.66739 12.4084 8.66739H9.72336C8.40332 8.66739 7.33079 7.59486 7.33079 6.27482V3.58975C7.33079 3.29724 7.20329 3.01223 6.97828 2.81722C6.76078 2.62222 6.46077 2.53222 6.17576 2.56972C4.41321 2.79472 2.79316 3.76225 1.73563 5.21729C0.670598 6.67984 0.280586 8.46489 0.618096 10.2499C1.10561 12.83 3.16817 14.8926 5.75575 15.3801C6.16826 15.4626 6.58077 15.5001 6.99328 15.5001C8.35082 15.5001 9.66336 15.0801 10.7809 14.2626C12.2359 13.205 13.2035 11.585 13.4285 9.82243C13.466 9.52992 13.376 9.23741 13.181 9.0199Z",
    fill: "#075FCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.001decdd10560d28dd08c1763d323dd0.svg";
export { ForwardRef as ReactComponent };